/**
 * Fixed top offset applied when a page-level banner (license / base-URL missing)
 * is visible. Must stay in sync with the rendered Banner / BaseUrlMissingBanner height.
 */
export const DESKTOP_BANNER_OFFSET = 40;
export const MOBILE_BANNER_OFFSET = 70;
